import { useContext } from 'react'

import Grid from '@mui/material/Grid'

import Details from 'layouts/business-account/components/Details'
import Notes from 'layouts/business-account/components/Notes'
import { FormContext } from 'layouts/business-account/constants'

import Analytics from '../Analytics'
import FeedbackTable from '../FeedbackTable'

function MainContent() {
	const formContext = useContext(FormContext)
	const { isNew } = formContext
	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Details />
			</Grid>
			<Grid item xs={12}>
				<Notes />
			</Grid>
			{!isNew && (
				<>
					<Grid item xs={12}>
						<Analytics />
					</Grid>
					<Grid item xs={12}>
						<FeedbackTable />
					</Grid>
				</>
			)}
		</Grid>
	)
}

export default MainContent
